export type QualityExportFormat = 'csv' | 'json' | 'markdown';
function toCsv(rows: Record<string, unknown>[]) {
  if (!rows.length) return '';
  const headers = Object.keys(rows[0]);
  const body = rows.map(row => headers.map(header => JSON.stringify(row[header] ?? '')).join(','));
  return [headers.join(','), ...body].join('\n');
}
function toMarkdown(rows: Record<string, unknown>[]) {
  if (!rows.length) return '# Export\n\n_No data_\n';
  const headers = Object.keys(rows[0]);
  const headerRow = `| ${headers.join(' | ')} |`;
  const separatorRow = `| ${headers.map(() => '---').join(' | ')} |`;
  const body = rows.map(row => `| ${headers.map(header => String(row[header] ?? '')).join(' | ')} |`);
  return ['# Quality Workspace Export', '', headerRow, separatorRow, ...body].join('\n');
}
export function exportQualityData(filenameBase: string, format: QualityExportFormat, rows: Record<string, unknown>[]) {
  const mime = format === 'json' ? 'application/json' : format === 'markdown' ? 'text/markdown' : 'text/csv';
  const content = format === 'json' ? JSON.stringify(rows, null, 2) : format === 'markdown' ? toMarkdown(rows) : toCsv(rows);
  const blob = new Blob([content], {
    type: mime
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${filenameBase}.${format === 'markdown' ? 'md' : format}`;
  anchor.click();
  URL.revokeObjectURL(url);
}